import { Typography, Row, Col } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import Card from "../card/Card";
import { useTheme } from "../../contexts/ThemeContext";

const { Text } = Typography;

const SynchronizationParameters = ({ onConfigureParameter }) => {
  const { theme } = useTheme();

  const parametersList = [
    {
      key: "dfc",
      label: "DFC",
      description: "Demonstrativo de Fluxo de Caixa",
      color: "#722ed1",
    },
    {
      key: "dre",
      label: "DRE e Indicadores",
      description: "Demonstração de Resultado do Exercício e Indicadores",
      color: "#1890ff",
    },
    {
      key: "orcamento",
      label: "Planejamento orçamentário",
      description: "Planejamento orçamentário da Empresa",
      color: "#189f5f",
    },
  ];

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <SettingOutlined style={{ fontSize: 16, color: theme.primary }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            Parâmetros da Empresa
          </span>
        </div>
      }
      style={{ marginBottom: 24 }}
    >
      <Text
        style={{
          display: "block",
          marginBottom: 24,
          color: "#8c8c8c",
          fontSize: 14,
        }}
      >
        Configure os módulos e sinais sincronizados
      </Text>

      <Row gutter={[16, 16]}>
        {parametersList.map((param) => (
          <Col xs={24} sm={12} md={8} key={param.key}>
            <div
              style={{
                borderRadius: 8,
                padding: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "all 0.3s",
                backgroundColor: theme.background,
                minHeight: 80,
                cursor: "pointer",
              }}
              onClick={() => {
                if (onConfigureParameter) {
                  onConfigureParameter(param.key);
                }
              }}
            >
              <div style={{ flex: 1, marginRight: 16 }}>
                <Text
                  style={{
                    fontWeight: 600,
                    fontSize: 14,
                    color: param.color,
                    display: "block",
                    marginBottom: 4,
                  }}
                >
                  {param.label}
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    color: "#8c8c8c",
                    lineHeight: "16px",
                  }}
                >
                  {param.description}
                </Text>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default SynchronizationParameters;
